import React from "react";
import Flex from "app/components/Flex";
import Loader from "./index";

export default props => (
  <Flex width="100%" height="100%" justifyContent="center" alignItems="center">
    <Loader {...props} />
  </Flex>
);
